import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=21a813e6&"
import script from "./uploader.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./uploader.vue?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports